import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { NavigationBar } from '../../Components/navigationbar/NavigationBar';
import { Footer } from '../../Components/Layout/footer/Footer';
import Layout from '../../Components/Layout';
import fourzerofour from '../../Assets/images/404.svg';
import fivehundred from '../../Assets/images/500.svg';

export function ErrorPage() {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const location = useLocation();

  const button = (
    <div className="text-center py-5">
      <button onClick={() => navigate(-1)} className="btn btn-link">
        <img alt="404" className="w-100" src={location.pathname === '/500' ? fivehundred : fourzerofour} />
      </button>
    </div>
  );

  if (isAuthenticated) {
    return <Layout showFooter>{button}</Layout>;
  }

  return (
    <div>
      <NavigationBar />
      {button}
      <Footer />
    </div>
  );
}
